import './polyfills';
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { initializeIcons } from '@uifabric/icons';
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";
import "./styles/global.css";
import "./assets/css/overrides/light-bootstrap-dashboard-react-override.css";
import AdminLayout from "layouts/Admin.jsx";
import Healthz from "healthz.jsx";

initializeIcons('https://static2.sharepointonline.com/files/fabric/assets/icons/');

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/portal" render={props => <AdminLayout {...props} />} />
      <Route path="/healthz" render={props => <Healthz {...props} />} />
      <Redirect exact from="/" to="/portal/home" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
